import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Typography,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  useMediaQuery,
} from '@mui/material';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { getOrderDetailsAction } from './API/Action';
import { toast } from 'react-toastify';
import StatusBadge from '../../../v2/MUI_custom_component/Badge/StatusBadge';
import { CustomButton, HumbeeTabs, TextField } from '../../../v2/MUI_custom_component';
import dayjs from 'dayjs';
import { deliveryTypeDropDown, OperationType, ORDER_STATUS } from '../../../utils/settings';
import { useDispatch, useSelector } from 'react-redux';
import { Delete, Edit, CheckCircle, Close } from '../../../components/icons';
import IconReusable from '../../../components/IconReusable';
import { hydrateDpFromOrder, resetDP, resetSelectedShipToParty, setDpRouteSource, setMoQData, setMaxDPQuantityAllowed, selectShipToParty, setReferencePricingGeography, resetReferencePricingGeography } from '../CreateDP/reducer/DpActions';
import { DP_ROUTE_SOURCE } from '../CreateDP/Enums';
import { mapOrderDetailsToDpState } from '../CreateDP/component/mapOrderDetailsToDp';
import { selectSelectedShipToPartyId, selectTotalDPQuantity, selectShipToPartyCarts,  selectPoOpenQty, selectMOQ } from '../CreateDP/reducer/DpSelectors';
import HumbeeModal from '../../../v2/MUI_custom_component/Modal/HumbeeModal';
import DisclaimerSvg from '../../Illustrration/components/DisclaimerSvg';
import { DeleteOrderAction, ModifyOrderAction } from '../CreateDP/API/Action';
import { buildModifyOrderPayload, buildProductInfo } from '../ModifyOrder';
import { toCapitalized } from '../../../v2/Utils/Capitalize';
import ViewInvoiceList from './ViewInvoiceList';


const DPDetails = () => {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [orderData, setOrderData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentShippingTab, setCurrentShippingTab] = useState(0);
  const [ openDeleteModal, setOpenDeleteModal ] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [editedQuantity, setEditedQuantity] = useState('');
  const [STPDeleteModal, setSTPDeleteModal] = useState(false)
  const [rowLoading, setRowLoading] = useState(null);
  const [deletingTabIndex, setDeletingTabIndex] = useState(null);
  const [openViewInvoiceList, setOpenViewInvoiceList] = useState(false);
  const [invoiceData, setInvoiceData] = useState([]);
  const selectMOQData = useSelector(selectMOQ)
  const totalDPQuantity = useSelector(selectTotalDPQuantity);
  const poRemainingQty = useSelector(selectPoOpenQty) 
  
  const { selectedSupplier: selectedManufacturer, selectedEntity: selectedCompanyEntity } = useSelector(
      (state) => state.entityReducer
  );
  const getDeliveryTypeLabel = (value) => {
    const type = deliveryTypeDropDown.find(t => t.value === value);
    return type ? type.label : '-';
  };
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const shipToPartyCarts = useSelector(selectShipToPartyCarts);
  const fetchOrderDetails = useCallback(async () => {
    dispatch(resetDP());
    dispatch(resetReferencePricingGeography());
    let orderIdFromUrl = params.orderId || params.id || params.orderNo;
    if (!orderIdFromUrl) {
      const pathParts = location.pathname.split('/');
      orderIdFromUrl = pathParts[pathParts.length - 1];
    }
    if (!orderIdFromUrl || orderIdFromUrl === 'dispatch-plan-detail') {
      setLoading(false);
      return;
    }
    setLoading(true);
    const config = new URLSearchParams();
    config.append('order_id', orderIdFromUrl);
    
    const { data, error, message } = await getOrderDetailsAction(config);
    
    if (!error) {
      dispatch(resetDP)
      setOrderData(data);
    } else {
      toast.error(message || 'Failed to fetch order details');
    }
    setLoading(false);
  }, [params.orderId, params.id, params.orderNo, location.pathname]);
  useEffect(() => {
    if(selectedManufacturer){
      fetchOrderDetails();
    }
  }, [fetchOrderDetails, selectedManufacturer, selectedCompanyEntity]);
  const DeleteDP = async(order_id) => {
    const payload = {
      order_id: order_id,
      user_esi_id: selectedCompanyEntity
    }
    setLoading(true)
    const { error, message } = await DeleteOrderAction(payload);
    setLoading(false)
    
    if (!error) {
        toast.success(message)
        navigate(`/dispatch-status-list`);
    }else{
        toast.error(message)
    }
  }
  const shipment_details = React.useMemo(() => {
    if (!shipToPartyCarts || Object.keys(shipToPartyCarts).length === 0) {
      return [];
    }
    return Object.values(shipToPartyCarts)
      .map((stp, index) => {
        const d = stp.shipToPartyDetails;
        return {
          activeTabIndex: stp.activeTabIndex || (index + 1), // Use index + 1 as fallback to maintain API order
          ship_to_party_summary: stp.ship_to_party_summary,
          ship_to_party_info: {
          humbee_so_id : d?.humbee_so_id,
          company_info: {
            id: d?.company_id,
            esi_id: d?.selected_esi_id,
            external_system_code: d?.selected_esi_info?.external_system_code,
            name: d?.company_name,
            phone: d?.company_phone_no,
            gst: d?.gstin,
          },
          address_info: {
            address: {
              address_line_1: d?.delivery_Address_line1,
              address_line_2: d?.delivery_Address_line2,
              address_line_3: d?.delivery_Address_line3,
            },
            pincode: d?.delivery_company_pincode,
            district_info: {
              id: d?.delivery_district_id,
              name: d?.delivery_district_name,
            },
            state_info: {
              id: d?.delivery_state_id,
              name: d?.delivery_state_name,
            },
            location_info: {
              location_id: d?.delivery_location_id,
              location_name: d?.delivery_location_name,
            },
          },
          receiver_info: {
            name: d?.receiver_name ?? '',
            phone_number: d?.receiver_mobile,
          },
          delivery_info: {
            delivery_type: d?.delivery_type,
            incoterms: d?.incoterms ?? 2,
          },
          pricing_geography_info: {
            pricing_geography_id: d?.pricing_geography_id,
            pricing_geography_name: d?.pricing_geography_name,
          },
        },
        product_summary_info: stp.cart.map((p) => ({
          product_id: p?.product_id,
          name: p?.product_name,
          product_logo: p?.product_image,
          description: p?.description,
          form_type: p?.form_type,
          order_product_delivery_id: p?.order_product_delivery_id,

          ordered: { ...p?.quantity },

          delivered: {
            quantity_in_bags: 0,
            quantity_in_metric_ton: 0,
            multiplier: p?.quantity.multiplier,
            unit: p?.quantity.unit,
            base_unit: p?.quantity.base_unit,
          },

          pending: { ...p.quantity },

          cancelled: {
            quantity_in_bags: 0,
            quantity_in_metric_ton: 0,
            multiplier: p?.quantity?.multiplier,
            unit: p.quantity.unit,
            base_unit: p?.quantity?.base_unit,
          },

          price_info: {
            unit: '₹',
            price_per_unit_ex_gst: p?.current_price_per_unit,
            total_value_ex_gst:
              p?.current_price_per_unit *
              p?.quantity.quantity_in_metric_ton,
          },
        })),
        invoice_info: stp?.invoice_info,
      };
    })
    .sort((a, b) => (a.activeTabIndex || 0) - (b.activeTabIndex || 0)); // Sort by activeTabIndex to preserve API response order
  }, [shipToPartyCarts]);
  const handleAddProducts = (shipToPartyId) => {
    dispatch(selectShipToParty(shipToPartyId));
    navigate('/create-dp', {
      state: {
        shipToPartyId: shipToPartyId,
        order_booking_id: order_details.humbee_booking_id,
        from: DP_ROUTE_SOURCE.DP_DETAILS,
      }
    });
  };
  const handleEditProduct = (shipmentIndex, productIndex, currentQuantity) => {
    const editKey = `${shipmentIndex}-${productIndex}`;
    setEditingProduct(editKey);
    setEditedQuantity(currentQuantity?.toString() || '');
  };
  const handleAddShipToParty = () => {
    dispatch(resetSelectedShipToParty());
    dispatch(setDpRouteSource(DP_ROUTE_SOURCE.DP_DETAILS));
    const firstStp = shipment_details[0];
    if (firstStp?.ship_to_party_info?.pricing_geography_info && shipment_details.length > 0) {
      dispatch(setReferencePricingGeography({
        pricing_geography_id: firstStp.ship_to_party_info.pricing_geography_info.pricing_geography_id,
      }));
    }
    navigate('/create-dp', {
      state: {
        order_booking_id: order_details.humbee_booking_id,
      }
    });
  };
  const [shiptopartyinfo, setshiptopartyinfo] = useState()
  const DeleteShiptoParty = async (shipment) => {
    setLoading(true);

    const payload = buildModifyOrderPayload({
      orderId: order_details.id,
      shipment,
      shipToPartyOperation: OperationType.DELETE,
      products: shipment.product_summary_info.map(p =>
        buildProductInfo(p, null)
      ),
    });

    const { error, message } = await ModifyOrderAction(
      payload,
      selectedCompanyEntity
    );

    setLoading(false);

    if (!error) {
      toast.success(message);
      setSTPDeleteModal(false);
      // Set current tab to first tab (index 0) after STP deletion
      setCurrentShippingTab(0);
      fetchOrderDetails();
    } else {
      toast.error(message);
    }
  };
  const handleDelteSTP = (stp_info, shipmentIndex) => {
    setDeletingTabIndex(shipmentIndex);
    setSTPDeleteModal(true)
    setshiptopartyinfo(stp_info)
  }
  const handleSaveProduct = async (shipmentIndex, productIndex, quantity) => {
    const rowKey = `${shipmentIndex}-${productIndex}`;
    const shipment = shipment_details[shipmentIndex];
    const product = shipment.product_summary_info[productIndex];

    setEditingProduct(null);
    setRowLoading(rowKey);

    const payload = buildModifyOrderPayload({
      orderId: order_details.id,
      shipment,
      products: [
        buildProductInfo(product, OperationType.UPDATE, Number(quantity)),
      ],
    });

    const { error, message } = await ModifyOrderAction(
      payload,
      selectedCompanyEntity
    );
    setRowLoading(null);
    if(!error){
      toast.success(message) 
      fetchOrderDetails()
    }else{
      toast.error(message);
    }
  };
  const handleDeleteProduct = async (shipmentIndex, productIndex) => {
    const rowKey = `${shipmentIndex}-${productIndex}`;
    setRowLoading(rowKey);
    const shipment = shipment_details[shipmentIndex];
    const product = shipment.product_summary_info[productIndex];

    const payload = buildModifyOrderPayload({
      orderId: order_details.id,
      shipment,
      products: [
        buildProductInfo(product, OperationType.DELETE),
      ],
    });

    const { error, message } = await ModifyOrderAction(
      payload,
      selectedCompanyEntity
    );

    setRowLoading(null);

    if (!error) {
      toast.success(message);
      setCurrentShippingTab((prev) => {
        if (deletingTabIndex < prev) return prev - 1;
        if (deletingTabIndex === prev) {
          return Math.max(0, prev - 1);
        }
        return prev;
      });

      setDeletingTabIndex(null);
      fetchOrderDetails();

    } else {
      toast.error(message);
    }
  };
  const UpdateSTPAddress = (shipment_details) =>{
    dispatch(setDpRouteSource(DP_ROUTE_SOURCE.DP_DETAILS));
    navigate('/dp-shiping-info', {
      state: {
        shipToPartyData: shipment_details,
        order_id: order_details.id,
        editMode: true,
      }
    });
  }
  const handleViewInvoiceList = () => {
    setOpenViewInvoiceList(true);
    setInvoiceData(shipment_details[currentShippingTab].invoice_info || []);
  }
  
  useEffect(()=>{
    if(orderData && orderData.order_details && selectedManufacturer){
      const dp_creation_qty = (orderData.order_details.po_remaining_qty) + (totalDPQuantity);
      const mappedDp = mapOrderDetailsToDpState(orderData, dp_creation_qty)
      dispatch(hydrateDpFromOrder(mappedDp)); 
    }
  },[orderData, totalDPQuantity, selectedManufacturer])
  const maxDPQuanitityAllowed = selectMOQData?.max_order_quantity - totalDPQuantity;
  useEffect(() => {
    if (maxDPQuanitityAllowed !== undefined && maxDPQuanitityAllowed !== null) {
      dispatch(setMaxDPQuantityAllowed(maxDPQuanitityAllowed));
    }
  }, [maxDPQuanitityAllowed, dispatch]);
  
  useEffect(() => {
      if (orderData?.min_max_moq_and_mov) {
          dispatch(setMoQData(orderData.min_max_moq_and_mov));
      }
  }, [orderData?.min_max_moq_and_mov]);
  
  if (loading && !orderData) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <CircularProgress />
      </Box>
    );
  }
  if (!orderData) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <Typography variant="h3">No order data available</Typography>
      </Box>
    );
  }
  const { order_details, quantity_summary, min_max_moq_and_mov } = orderData;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2}}>
      <Box sx={{ pt: { xs: 2, md: 4 }, px: { xs: 2, md: 4 },display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h2">
            Order Summary
          </Typography>
          {order_details.order_status === ORDER_STATUS.PENDING && (
            <CustomButton
              variant="text"
              color="primary"
              size={isMobile ? "small" : "medium"}
              label="Cancel DP"
              leftIcon={Delete}
              onClick={()=>setOpenDeleteModal(true)}
            />
          )}
        </Box>
        <Grid container sx={{ gap: 2, alignItems: 'stretch', display: 'flex', flexDirection: { xs: 'column', md: 'row' } }}>
          <Grid item xs={12} md={3}  sx={{ gap: { xs: 0, md: 2 }, display: 'flex', flexDirection: { md:'column'}, justifyContent:'space-between', background: '#fff', borderRadius: 2, p: 2 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography variant="labelM" sx={{ minWidth: {xs:'90px', md: '120px'}, color: '#666' }}>
                  Order Date
                </Typography>
                <Typography variant="p3">
                  {dayjs(order_details.date).format('DD-MM-YYYY')}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography variant="labelM" sx={{ minWidth: {xs:'90px', md: '120px'}, color: '#666' }}>
                  Order ID
                </Typography>
                <Typography variant="p3">
                  {order_details.id}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography variant="labelM" sx={{ minWidth: {xs:'90px', md: '120px'}, color: '#666' }}>
                  Order Qty.
                </Typography>
                <Typography variant="p3">
                  {quantity_summary.ordered?.quantity_in_metric_ton} {quantity_summary.ordered?.unit}
                </Typography>
              </Box>
            </Box>
            <Box>
              <StatusBadge
                label={order_details.order_status}
                status={order_details.order_status}
                size={isMobile ? 'small' : 'medium'}
              />
            </Box>
          </Grid>
          {shipment_details?.map((shipment, index) => (
            <Grid item xs={12} md key={index} sx={{ display: {xs: 'none', md:'block'}, minWidth:{ xs: shipment_details.length > 1 ? '280px' : '100%', md: 'unset'} }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', gap:1, background: '#fff', borderRadius: 2, p: 2 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 ,}}>
                  <Box sx={{ display: 'flex', gap: 2, }}>
                    <Typography variant="labelM" sx={{ minWidth: {xs:'90px', md: '120px'}, color: '#666' }}>
                      Ship to Party
                    </Typography>
                    <Typography variant="bodyM">
                      { shipment?.ship_to_party_summary?.ship_to_party_name || '-' }
                    </Typography>
                  </Box>
                  {shipment?.ship_to_party_summary?.so_id && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, }}>
                      <Typography variant="labelM" sx={{ minWidth: {xs:'90px', md: '120px'}, color: '#666' }}>
                        SO ID
                      </Typography>
                      <Typography variant="bodyM">
                        { shipment?.ship_to_party_summary?.so_id }
                      </Typography>
                    </Box>
                  )}
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                    {shipment?.ship_to_party_summary?.quantity_info?.map((detail, index) => (
                      <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 2,}}>
                        <Typography
                          variant="labelM"
                          sx={{
                            minWidth: { xs: '90px', md: '120px' },
                            color: '#666',
                          }}
                        >
                          {detail?.label}
                        </Typography>

                        <Typography variant="p3">
                          {detail?.value}
                        </Typography>
                      </Box>
                    ))}
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Box sx={{ display: { xs:'flex', md:'none'}, px: 2, scrollbarWidth: 'none', justifyContent: 'space-between', overflowX: { xs: 'scroll', md: 'visible' }, width: {md: '73.5%'}, gap: 1 }} >
        {shipment_details?.map((shipment, index) => (
          <Grid item xs={12} md key={index} sx={{ minWidth:{ xs: shipment_details.length > 1 ? '280px' : '100%', md: 'unset'} }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', gap:1, background: '#fff', borderRadius: 2, p: 2 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 ,}}>
                <Box sx={{ display: 'flex', gap: 2, }}>
                  <Typography variant="labelM" sx={{ minWidth: {xs:'90px', md: '120px'}, color: '#666' }}>
                    Ship to Party
                  </Typography>
                  <Typography variant="bodyM">
                    { shipment?.ship_to_party_summary?.ship_to_party_name || '-' }
                  </Typography>
                </Box>
                {shipment?.ship_to_party_summary?.so_id && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, }}>
                    <Typography variant="labelM" sx={{ minWidth: {xs:'90px', md: '120px'}, color: '#666' }}>
                      SO ID
                    </Typography>
                    <Typography variant="bodyM">
                      { shipment?.ship_to_party_summary?.so_id }
                    </Typography>
                  </Box>
                )}
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                  {shipment?.ship_to_party_summary?.quantity_info?.map((detail, index) => (
                    <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 2,}}>
                      <Typography
                        variant="labelM"
                        sx={{
                          minWidth: { xs: '90px', md: '120px' },
                          color: '#666',
                        }}
                      >
                        {detail?.label}
                      </Typography>

                      <Typography variant="p3">
                        {detail?.value}
                      </Typography>
                    </Box>
                  ))}
              </Box>
            </Box>
          </Grid>
        ))}
      </Box>
      <Box sx={{ px: { xs: 2, md: 4 },display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box sx={{ background: '#fff', borderRadius: 2, p: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Typography variant="h2">
                Billing Details
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                {order_details.total_bill_info?.map((item, index) => (
                  <Box key={index} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: index === order_details.total_bill_info.length - 1 ? '1px solid #D9D9D9' : 'none', pt: index === order_details.total_bill_info.length - 1  ? 1 : 0 }}>
                    <Typography variant="labelM">
                      {item.display_name}
                    </Typography>
                    <Typography variant="p3" sx={{ fontWeight: index === order_details.total_bill_info.length - 1 && 600 }}>
                      {item.label}
                    </Typography>
                  </Box>
                ))}
              </Box>
          </Box>
          {shipment_details && shipment_details.length > 0 && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 0.5, md:1 }}}>
              <Typography variant="h2">
                Shipping Info
              </Typography>
              <HumbeeTabs
                tabVariant={isMobile ? 'small' : 'default'}
                data={[...shipment_details.filter(item => !item.isAddTab), ...((shipment_details.filter(item => !item.isAddTab).length < 3 && order_details.order_status === ORDER_STATUS.PENDING)  ? [{ isAddTab: true, icon: 'Add', disabled: totalDPQuantity >= poRemainingQty }] : [])]}
                currentTab={currentShippingTab}
                onChange={(e, newValue) => {
                  const combinedData = [...shipment_details.filter(item => !item.isAddTab), ...((shipment_details.filter(item => !item.isAddTab).length < 3 && order_details.order_status === ORDER_STATUS.PENDING)  ? [{ isAddTab: true, icon: 'Add' }] : [])];
                  const tab = combinedData[newValue];

                  if (tab?.isAddTab) {
                    handleAddShipToParty();
                    return;
                  }

                  setCurrentShippingTab(newValue);
                }}
                getTabIcon={(shipment, index, isSelected) => {
                  if (shipment.icon || shipment.isAddTab){
                    return (
                      <IconReusable 
                        name={shipment.icon} 
                        size={20} 
                      />
                    );
                  }
                  return null;
                }}
                getTabLabel={(shipment, index) => 
                  (shipment.isAddTab && order_details.order_status === ORDER_STATUS.PENDING)
                    ? 
                    'Add Ship to Party'
                    : `Ship to Party ${index + 1}`
                }
                getTabKey={(shipment, index) => 
                  (shipment.isAddTab && order_details.order_status === ORDER_STATUS.PENDING) ? 'add-tab' : (shipment.ship_to_party_summary?.so_id)
                }
                renderTabContent={(shipment, shipmentIndex) => {
                  if (shipment.isAddTab) {
                    return null;
                  }
                  return (
                  <Box key={shipmentIndex} sx={{ background: '#fff', borderRadius: 2, p: 2, display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
                    <Box sx={{ display: 'flex', flexDirection: {xs: 'column', md: 'row'}, gap:{ xs: 0.5, md: 0}, justifyContent: 'space-between'}}>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between'}}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Typography variant="labelM" sx={{ minWidth: {xs:'150px', md: '120px'}, color: '#666' }}>
                              Firm Name
                            </Typography>
                            <Typography variant="p3">
                              {shipment.ship_to_party_info?.company_info?.name || '-'}
                            </Typography>
                          </Box>
                          {order_details.order_status === ORDER_STATUS.PENDING && (!shipment_details.length === 1) &&  (
                            <Box sx={{ display: { xs: 'flex', md: 'none'}}}>
                              <IconButton
                                size='small'
                                sx={{ color: '#995A00', width: {xs: '24px', md: '40px'}, height: {xs: '24px', md: '40px'} }}
                                onClick={()=>setOpenDeleteModal(true)}
                              >
                                <IconReusable name='Delete' size={isMobile ? 16: 24 } color={'#995A00'} sx={{ cursor: 'pointer' }} />
                              </IconButton>
                            </Box>
                          )}
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                          <Typography variant="labelM" sx={{ minWidth: {xs:'150px', md: '120px'}, color: '#666' }}>
                            Phone
                          </Typography>
                          <Typography variant="p3">
                            {shipment.ship_to_party_info?.company_info?.phone || 'N/A'}
                          </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                          <Typography variant="labelM" sx={{ minWidth: {xs:'150px', md: '120px'}, color: '#666' }}>
                            Address
                          </Typography>
                          <Typography variant="p3" sx={{ maxWidth: { xs:'200px', md: '450px'}, }}>
                            {toCapitalized([
                              shipment.ship_to_party_info?.address_info?.address?.address_line_1,
                              shipment.ship_to_party_info?.address_info?.address?.address_line_2,
                              shipment.ship_to_party_info?.address_info?.address?.address_line_3,
                              shipment.ship_to_party_info?.address_info?.district_info?.name,
                              shipment.ship_to_party_info?.address_info?.state_info?.name,
                              shipment.ship_to_party_info?.address_info?.pincode
                            ].filter(Boolean).join(', '))}
                          </Typography>
                          {order_details.order_status === ORDER_STATUS.PENDING && (
                            <IconButton
                              size='small'
                              sx={{ color: '#995A00'}}
                              onClick={()=>UpdateSTPAddress(shipToPartyCarts[shipment.ship_to_party_info.company_info.id].shipToPartyDetails)}
                            >
                              <IconReusable name='Edit' size={18} color={'#995A00'} sx={{ cursor: 'pointer' }} />
                            </IconButton>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                          <Typography variant="labelM" sx={{ minWidth: '150px', color: '#666' }}>
                            ERP Code
                          </Typography>
                          <Typography variant="p3">
                            {shipment.ship_to_party_info?.company_info?.external_system_code || '-'}
                          </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                          <Typography variant="labelM" sx={{ minWidth: '150px', color: '#666' }}>
                            Delivery Type
                          </Typography>
                          <Typography variant="p3">
                            {getDeliveryTypeLabel(shipment.ship_to_party_info?.delivery_info?.delivery_type)}
                          </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                          <Typography variant="labelM" sx={{ minWidth: '150px', color: '#666' }}>
                            Reciever's name
                          </Typography>
                          <Typography variant="p3">
                            {shipment.ship_to_party_info?.receiver_info?.name || '-'}
                          </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                          <Typography variant="labelM" sx={{ minWidth: '150px', color: '#666' }}>
                            Reciever's Mobile number
                          </Typography>
                          <Typography variant="p3">
                            {shipment?.ship_to_party_info?.receiver_info?.phone_number || '-'}
                          </Typography>
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'column' }, justifyContent: 'space-between', gap: 1, alignItems: { xs: 'flex-start', md: 'end' } }}>
                        {shipment.invoice_info?.length > 0 && (
                          <CustomButton
                            variant="outlined"
                            color='primary'
                            size={isMobile ? "small" : "medium"}
                            sx={{ mt: { xs: 1, md: 0 }}}
                            onClick={handleViewInvoiceList}
                            label="View Invoice Details"
                          />
                        )}
                        {order_details.order_status === ORDER_STATUS.PENDING && ( shipment_details.length > 1) &&  (
                          <CustomButton
                            variant="text"
                            color='neutral'
                            size={isMobile ? "small" : "medium"}
                            leftIcon={Delete}
                            sx={{ display: { xs:'none', md: 'flex' }}}
                            onClick={()=> handleDelteSTP(shipment, shipmentIndex)}
                            label="Delete Ship to Party"
                          />
                        )}
                        
                        {order_details.order_status === ORDER_STATUS.PENDING && (
                          <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                          <CustomButton
                            variant="outlined"
                            color='primary'
                            size={isMobile ? "small" : "medium"}
                            // sx={{ width: 'auto', mt: { xs: 2, md: 0 }}}
                            onClick={() => handleAddProducts(shipment.ship_to_party_info?.company_info?.id)} 
                            label="Add Products"
                            disabled={totalDPQuantity >= poRemainingQty}
                          />
                          </Box>
                        )}
                      </Box>
                    </Box>
                    <TableContainer 
                      component={Paper} 
                      variant="outlined"
                      sx={{ 
                        border: 'none',
                        boxShadow: 'none',
                        borderRadius: '16px',
                        overflowX: 'scroll'
                      }}
                    >
                      <Table>
                        <TableHead>
                          <TableRow sx={{ 
                            backgroundColor: '#E5E5E5',
                            '& .MuiTableCell-root': {
                              borderRight: 'none',
                              borderBottom: '1px solid #8C8C8C',
                            }
                          }}>
                            {order_details.order_status === ORDER_STATUS.PENDING && (
                              <TableCell sx={{ width: {xs:'80px', md: '112px'}, display: { xs: 'table-cell', md: 'none' } }}></TableCell>
                            )}
                            <TableCell><Typography variant='labelM' sx={{ minWidth: { xs:'120px', md:'200px'}}}>Product Name</Typography></TableCell>
                            <TableCell><Typography variant='labelM' sx={{ minWidth: { xs:'90px', md:'140px' }}}>Order Qty.</Typography></TableCell>
                            {order_details.order_status !== ORDER_STATUS.PENDING && (
                              <TableCell><Typography variant='labelM' sx={{ minWidth: { xs:'90px', md:'140px' }}}>Delivered Qty.</Typography></TableCell>
                            )}
                            {order_details.order_status !== ORDER_STATUS.PENDING && (
                              <TableCell><Typography variant='labelM' sx={{ minWidth: { xs:'90px', md:'140px' }}}>Cancelled Qty.</Typography></TableCell>
                            )}
                            <TableCell><Typography variant='labelM' sx={{ minWidth: { xs:'90px', md:'140px' }}}>Price/Unit INR</Typography></TableCell>
                            <TableCell><Typography variant='labelM' sx={{ minWidth: { xs:'90px', md:'140px' }}}>Total Value INR</Typography></TableCell>
                            {order_details.order_status === ORDER_STATUS.PENDING && (
                              <TableCell sx={{ width: {xs:'80px', md: '112px'}, display: { xs: 'none', md: 'table-cell' } }}></TableCell>
                            )}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {shipment.product_summary_info?.map((product, productIndex) => (
                            <TableRow key={productIndex} sx={{
                              backgroundColor: '#fff',
                              '& .MuiTableCell-root': {
                                borderBottom: 'none',
                                borderRight: 'none',
                                padding: { xs: 1, md: 2 }
                              }
                            }}>
                              {order_details.order_status === ORDER_STATUS.PENDING && (
                                <TableCell sx={{ display: { xs: 'flex', md: 'none' }, gap: 0.5 }}>
                                  {rowLoading === `${shipmentIndex}-${productIndex}` && (
                                    <CircularProgress size={20} sx={{ color: '#995A00' }} />
                                  )}

                                  {editingProduct === `${shipmentIndex}-${productIndex}` ? (
                                    <>
                                      <IconButton
                                        size="small"
                                        onClick={() => setEditingProduct(null)}
                                        sx={{ color: '#995A00' }}
                                      >
                                        <Close width='16px' height='16px'/>
                                      </IconButton>
                                      <IconButton
                                        size="small"
                                        onClick={() => handleSaveProduct(shipmentIndex, productIndex, editedQuantity)}
                                        sx={{ color: '#995A00' }}
                                      >
                                        <CheckCircle  width='16px' height='16px' />
                                      </IconButton>
                                    </>
                                  ) : (
                                    <IconButton
                                      size="small"
                                      onClick={() => handleEditProduct(shipmentIndex, productIndex, product.ordered?.quantity_in_metric_ton)}
                                      sx={{ color: '#995A00' }}
                                    >
                                      <Edit  width='16px' height='16px' />
                                    </IconButton>
                                  )}
                                  
                                  <IconButton
                                    size="small"
                                    onClick={() => handleDeleteProduct(shipmentIndex, productIndex)}
                                    sx={{ color: '#995A00' }}
                                  >
                                    <Delete  width='16px' height='16px' />
                                  </IconButton>
                                </TableCell>
                              )}
                              <TableCell>
                                <Typography variant="p3">
                                  {product.name}
                                </Typography>
                              </TableCell>
                              <TableCell>
                                {order_details.order_status === ORDER_STATUS.PENDING && editingProduct === `${shipmentIndex}-${productIndex}` ? (
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <TextField
                                      
                                      value={editedQuantity}
                                      onChange={(e) => setEditedQuantity(e.target.value)}
                                      sx={{ width: '50px', fontSize: '13px' }}
                                      type="number"
                                      variant='standard'
                                    />
                                    {product.delivered?.unit}
                                  </Box>
                                  
                                ) : (
                                  <Typography variant="p3">
                                    {product.ordered?.quantity_in_metric_ton?.toFixed(2)} {product.delivered?.unit}
                                  </Typography>
                                )}
                              </TableCell>
                              {order_details.order_status !== ORDER_STATUS.PENDING && (
                                <TableCell>
                                  <Typography variant="p3">
                                    {product.delivered?.quantity_in_metric_ton?.toFixed(2)} {product.delivered?.unit}
                                  </Typography>
                                </TableCell>
                              )}
                              {order_details.order_status !== ORDER_STATUS.PENDING && (
                                <TableCell>
                                  <Typography variant="p3">
                                    {product.cancelled?.quantity_in_metric_ton?.toFixed(2)} {product.delivered?.unit}
                                  </Typography>
                                </TableCell>
                              )}
                              <TableCell>
                                <Typography variant="p3">
                                  {product.price_info?.unit} {product.price_info?.price_per_unit_ex_gst?.toFixed(2)}
                                </Typography>
                              </TableCell>
                              <TableCell>
                                <Typography variant="p3">
                                  {product.price_info?.unit} {product.price_info?.total_value_ex_gst?.toFixed(2)}
                                </Typography>
                              </TableCell>
                              {order_details.order_status === ORDER_STATUS.PENDING && (
                                <TableCell sx={{ display: { xs: 'none', md: 'flex' }, gap: 1 }}>
                                  
                                  {rowLoading === `${shipmentIndex}-${productIndex}` && (
                                    <CircularProgress size={20} sx={{ color: '#995A00' }} />
                                  )}
                                  {editingProduct === `${shipmentIndex}-${productIndex}` ? (
                                    <>
                                      <IconButton
                                        size="small"
                                        onClick={() => setEditingProduct(null)}
                                        sx={{ color: '#995A00' }}
                                      >
                                        <Close width='24px' height='24px'/>
                                      </IconButton>
                                      <IconButton
                                        size="small"
                                        onClick={() => handleSaveProduct(shipmentIndex, productIndex, editedQuantity)}
                                        sx={{ color: '#995A00' }}
                                      >
                                        <CheckCircle  width='24px' height='24px' />
                                      </IconButton>
                                    </>
                                  ) : (
                                    <IconButton
                                      size="small"
                                      onClick={() => handleEditProduct(shipmentIndex, productIndex, product.ordered?.quantity_in_metric_ton)}
                                      sx={{ color: '#995A00' }}
                                    >
                                      <Edit width='24px' height='24px' />
                                    </IconButton>
                                  )}
                                  <IconButton
                                    size="small"
                                    onClick={() => handleDeleteProduct(shipmentIndex, productIndex)}
                                    sx={{ color: '#995A00' }}
                                  >
                                    <Delete width='24px' height='24px' />
                                  </IconButton>
                                </TableCell>
                              )}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                  );
                }}
                tabType="dashed"
              />
            </Box>
          )}
          <HumbeeModal
            open={openDeleteModal || STPDeleteModal}
            loading={loading}
            title={ STPDeleteModal ? 'Are you sure you want to Delete this Ship to Party?' : 'Are you sure you want to cancel this DP?' }
            subtitle='This action cannot be undone. All data would be lost.'
            cancelLabel = "No"
            onClose={() => STPDeleteModal ? setSTPDeleteModal(false) :setOpenDeleteModal(false)}
            confirmLabel = "Yes"
            onConfirm={()=> STPDeleteModal ? DeleteShiptoParty(shiptopartyinfo) : DeleteDP(order_details.id)}
            illustration={<DisclaimerSvg />}
            width={{ xs: 400 , md:  400 }}
          />
            <ViewInvoiceList
                open={openViewInvoiceList}
                onClose={() => setOpenViewInvoiceList(false)}
                invoiceData={invoiceData}
            />
      </Box>
    </Box>
  );
};
export default DPDetails;